<form [formGroup]="nameForm" autocomplete="off">
    <p class="mvd_alert--label" *ngIf="customerNameId != 0 && customerNameTypeId == 2">
        <i class="material-icons">warning</i> Warning – changing this information will override the current information. Current information will be stored as an AKA.
    </p>
    <p class="mvd_alert--label" *ngIf="customerNameId != 0 && customerNameTypeId == 3">
        <i class="material-icons">warning</i> Warning – changing this information will override the current information. Current information will be stored as DBA.
    </p>
    <p class="mvd_alert--label" *ngIf="customerNameId != 0 && (customerNameTypeId == 6 || customerNameTypeId == 7)">
        <i class="material-icons">warning</i> Warning – changing this information will override the current information.
    </p>
    <fieldset>
        <div class="row" *ngIf="customerNameId == 0">
            <div class="col-sm-3 mvd_form-group">
                <label>Name Type</label>
                <select class="mvd_form-control" formControlName="nameTypeId">
                    <option *ngFor="let type of customerNameTypes" [ngValue]="type.id">{{ type.displayValue }}</option>
                </select>
            </div>
        </div>
        <div formGroupName="individual" class="row" *ngIf="customerTypeId == 1 && (customerNameTypeId == 7 || customerNameTypeId == 2)">
            <div class="col-sm-3 mvd_form-group">
                <label>First Name</label>
                <input class="mvd_form-control" type="text" formControlName="firstName" maxlength="50" trim="blur"/>
            </div>
            <div class="col-sm-3 mvd_form-group">
                <label>Middle Name</label>
                <input class="mvd_form-control" type="text" formControlName="middleName" maxlength="50" trim="blur"/>
            </div>
            <div class="col-sm-4 mvd_form-group">
                <label class="required" title="* Required">Last Name</label>
                <input class="mvd_form-control" type="text" formControlName="lastName" maxlength="70" trim="blur"/>
                <div class="mvd_alert__validation">
                    <div class="mvd_alert__rule" *ngIf="nameForm.get('individual')?.get('lastName')?.hasError('required')">Last Name is required</div>
                </div>
            </div>
            <div class="col-sm-2 mvd_form-group">
                <label>Suffix</label>
                <select class="mvd_form-control" formControlName="suffixId">
                    <option [ngValue]="null"></option>
                    <option [ngValue]="suffix.id" *ngFor="let suffix of customerSuffixTypes">{{ suffix.displayValue }}</option>
                </select>
            </div>
        </div>
        <div formGroupName="organization" class="row" *ngIf="customerNameTypeId == 3 || customerNameTypeId == 6 || (customerTypeId == 2 && customerNameTypeId == 7)">
            <div class="col-sm-5 mvd_form-group">
                <label class="required" title="* Required" *ngIf="customerNameTypeId == 3">Organization Name</label>
                <label class="required" title="* Required" *ngIf="customerNameTypeId == 6">DBA Name</label>
                <label class="required" title="* Required" *ngIf="customerNameTypeId == 7">AKA Name</label>
                <input class="mvd_form-control" type="text" formControlName="organizationName" trim="blur"/>
                <div class="mvd_alert__validation">
                    <div class="mvd_alert__rule" *ngIf="nameForm.get('organization')?.get('organizationName')?.hasError('required')">
                        {{ customerType }} is required
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</form>